import React from "react";
import AbtStatisticsUI from "../component/AbtStatisticsUI";

const AbtStatistics = ()=>{
    return(
        <div>
            <AbtStatisticsUI />
        </div>
    )
}

export default AbtStatistics